import routes from '@/routes/routes'
import { createRouter, createWebHistory } from 'vue-router'
import store from '@/store/index'

const router = createRouter({
  history: createWebHistory(),
  routes,
  linkActiveClass: 'active'
})

  
// redirect to login page if not logged in and trying to access a restricted page
router.beforeEach((to, from, next) => {

  // we do not need a guard for public paths
  if ((to.meta && to.meta.public === true)) {
    next();
    return;
  }

  store.dispatch('authentication/validateActiveSession').then(() => {
    restoreImpersonation(to, next);
  }).catch((error) => {
    console.error('Error during session validation', error);
    next({name: 'home'});
  })
});

function restoreImpersonation(to, next) {
  const isAdmin = store.getters['authentication/getAppUser']?.isAdmin;
  const isAlreadyImpersonating = store.getters['authentication/isImpersonating'];
  const impersonateUser = store.getters['authentication/impersonateUser'];

  // If already impersonating but query params are missing, add them
  if (isAlreadyImpersonating && impersonateUser && !to.query.impersonate) {
    next({
      ...to,
      query: { ...to.query, impersonate: impersonateUser.id, impersonate_name: impersonateUser.name }
    });
    return;
  }

  // If not impersonating, try to restore from query param or sessionStorage
  if (isAdmin && !isAlreadyImpersonating) {
    const queryId = to.query.impersonate;
    if (queryId) {
      const name = to.query.impersonate_name || `Affiliate #${queryId}`;
      store.dispatch('authentication/startImpersonation', { id: Number(queryId), name });
      next();
      return;
    }

    const stored = sessionStorage.getItem('fh_impersonate');
    if (stored) {
      try {
        const { id, name } = JSON.parse(stored);
        store.dispatch('authentication/startImpersonation', { id, name });
        next({
          ...to,
          query: { ...to.query, impersonate: id, impersonate_name: name }
        });
        return;
      } catch (e) {
        sessionStorage.removeItem('fh_impersonate');
      }
    }
  }

  next();
}

export default router;
